<ng-template #modal>
	<div style="padding: 2.5rem" 
	[ngClass]="[ isHamburgerMenu ? 'hamburger-class': '',
			    isMobileDevice ? 'mobile-class': '' ]" >
		<button *ngIf="!hideCloseBtn" [ngClass]="isHamburgerMenu ? 'modal__burger-close-button' : 
		'modal__close-button'" class="btn p-0" type="button" (click)="close()">
			<i class="icon-close" style="font-size: 0.875rem" aria-hidden="true"></i>
		</button>
		<div class="modal-content">
			<ng-content></ng-content>
		</div>
	</div>
</ng-template>